import * as React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DynamicSizeList as List } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import memoize from "memoize-one";

import Comment from "./Comment";

const createItemData = memoize((commentData, searchTerm) => ({
  commentData,
  searchTerm,
}));

const Comments = ({ commentData, searchTerm }) => {
  const itemData = createItemData(commentData, searchTerm);
  return (
    <Row style={{ backgroundColor: "ghostwhite" }}>
      <Col md={{ span: 12 }} className="lead comment-count" />

      <Col md={{ span: 12 }} id="content" style={{ minHeight: "100vh" }}>
        <AutoSizer defaultWidth={1920} defaultHeight={1080}>
          {({ width, height }) => {
            return (
              <List
                height={height}
                itemCount={commentData.length}
                width={width}
                itemData={itemData}
              >
                {Comment}
              </List>
            );
          }}
        </AutoSizer>
      </Col>
      <div id="delay" />
    </Row>
  );
};

export default Comments;
